<template>
    <div class="menu-wrapper">
        <template v-for="(item,index) in routes">
            <el-submenu :index="item.path || index+''" v-if="item.child">
                <template slot="title">
                    <i :class="item.icon" v-if="item.icon"></i>
                    <span slot="title" v-text="item.title"></span>
                </template>
                <el-menu-item :index="el.path || ix+''" v-for="(el,ix) in item.child" :key="ix">
                    <i :class="el.icon" v-if="el.icon"></i>
                    <span slot="title" v-text="el.title"></span>
                </el-menu-item>
            </el-submenu>
            <el-menu-item  :index="item.path || index+''" v-else>
                <i :class="item.icon" v-if="item.icon"></i>
                <span slot="title" v-text="item.title"></span>
            </el-menu-item>
        </template>
    </div>
</template>

<script>
export default {
    name: 'SidebarItem',
    props: {
        routes: {
            type: Array,
        },
    },
    methods: {
    },
};
</script>



// WEBPACK FOOTER //
// src/components_v3/layout/left-sider/SidebarItem.vue